/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Booking_Starting_PackageInputs */

const en_booking_starting_package = /** @type {(inputs: Booking_Starting_PackageInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Starting your ${i?.count}-lesson package with this session.`)
};

const es_booking_starting_package = /** @type {(inputs: Booking_Starting_PackageInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Con esta sesión comienza tu paquete de ${i?.count} lecciones.`)
};

const de_booking_starting_package = /** @type {(inputs: Booking_Starting_PackageInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Mit dieser Golfstunde beginnt Ihr Paket mit ${i?.count} Golfstunden.`)
};

const zh_booking_starting_package = /** @type {(inputs: Booking_Starting_PackageInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`本节课将开启你的 ${i?.count} 节课套餐。`)
};

const ar_booking_starting_package = /** @type {(inputs: Booking_Starting_PackageInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`تبدأ بهذه الجلسة باقتك (عدد الدروس: ${i?.count}).`)
};

const fr_booking_starting_package = /** @type {(inputs: Booking_Starting_PackageInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Votre forfait de ${i?.count} cours commence avec cette séance.`)
};

const vi_booking_starting_package = /** @type {(inputs: Booking_Starting_PackageInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Bắt đầu gói ${i?.count} buổi với buổi học này.`)
};

const sw_booking_starting_package = /** @type {(inputs: Booking_Starting_PackageInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Kifurushi chako cha masomo ${i?.count} kinaanza na kipindi hiki.`)
};

const th_booking_starting_package = /** @type {(inputs: Booking_Starting_PackageInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`เซสชันนี้จะเริ่มแพ็กเกจเรียน ${i?.count} ครั้งของคุณ`)
};

const bs_booking_starting_package = /** @type {(inputs: Booking_Starting_PackageInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Počinjete paket od ${i?.count} lekcija ovom sesijom.`)
};

const ja_booking_starting_package = /** @type {(inputs: Booking_Starting_PackageInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`このセッションから${i?.count}回レッスンパッケージを開始します。`)
};

const ko_booking_starting_package = /** @type {(inputs: Booking_Starting_PackageInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`이번 세션으로 ${i?.count}회 레슨 패키지를 시작합니다.`)
};

const pt_booking_starting_package = /** @type {(inputs: Booking_Starting_PackageInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Esta sessão dá início ao seu pacote de ${i?.count} aulas.`)
};

const it_booking_starting_package = /** @type {(inputs: Booking_Starting_PackageInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Il tuo pacchetto da ${i?.count} lezioni inizia con questa sessione.`)
};

const sv_booking_starting_package = /** @type {(inputs: Booking_Starting_PackageInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Ditt paket med ${i?.count} lektioner börjar med den här sessionen.`)
};

const nl_booking_starting_package = /** @type {(inputs: Booking_Starting_PackageInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Je pakket van ${i?.count} lessen begint met deze sessie.`)
};

const da_booking_starting_package = /** @type {(inputs: Booking_Starting_PackageInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Din pakke med ${i?.count} lektioner starter med denne session.`)
};

const nb_booking_starting_package = /** @type {(inputs: Booking_Starting_PackageInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Pakken din med ${i?.count} leksjoner starter med denne økten.`)
};

const fi_booking_starting_package = /** @type {(inputs: Booking_Starting_PackageInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} oppitunnin pakettisi alkaa tästä kerrasta.`)
};

const pl_booking_starting_package = /** @type {(inputs: Booking_Starting_PackageInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Ta sesja rozpoczyna Twój pakiet ${i?.count} lekcji.`)
};

const ru_booking_starting_package = /** @type {(inputs: Booking_Starting_PackageInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Этим занятием начинается ваш пакет из ${i?.count} уроков.`)
};

const tr_booking_starting_package = /** @type {(inputs: Booking_Starting_PackageInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} derslik paketiniz bu seansla başlıyor.`)
};

const hi_booking_starting_package = /** @type {(inputs: Booking_Starting_PackageInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`इस सत्र से आपका ${i?.count} पाठों वाला पैकेज शुरू हो रहा है।`)
};

const id_booking_starting_package = /** @type {(inputs: Booking_Starting_PackageInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Anda memulai paket ${i?.count} pelajaran dengan sesi ini.`)
};

const ms_booking_starting_package = /** @type {(inputs: Booking_Starting_PackageInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Memulakan pakej ${i?.count} pelajaran anda dengan sesi ini.`)
};

const cs_booking_starting_package = /** @type {(inputs: Booking_Starting_PackageInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Touto lekcí začíná váš balíček ${i?.count} lekcí.`)
};

const el_booking_starting_package = /** @type {(inputs: Booking_Starting_PackageInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Το πακέτο ${i?.count} μαθημάτων σας ξεκινά με αυτή τη συνεδρία.`)
};

const he_booking_starting_package = /** @type {(inputs: Booking_Starting_PackageInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`חבילת ${i?.count} השיעורים שלכם מתחילה במפגש הזה.`)
};

const af_booking_starting_package = /** @type {(inputs: Booking_Starting_PackageInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Jy begin jou ${i?.count}-lespakket met hierdie sessie.`)
};

const hu_booking_starting_package = /** @type {(inputs: Booking_Starting_PackageInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Ezzel a foglalkozással kezdődik a csomagod (${i?.count} óra).`)
};

/**
* | output |
* | --- |
* | "Starting your {count}-lesson package with this session." |
*
* @param {Booking_Starting_PackageInputs} inputs
* @param {{ locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }} options
* @returns {LocalizedString}
*/
export const booking_starting_package = /** @type {((inputs: Booking_Starting_PackageInputs, options?: { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Booking_Starting_PackageInputs, { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_booking_starting_package(inputs)
	if (locale === "de") return de_booking_starting_package(inputs)
	if (locale === "zh") return zh_booking_starting_package(inputs)
	if (locale === "ar") return ar_booking_starting_package(inputs)
	if (locale === "fr") return fr_booking_starting_package(inputs)
	if (locale === "vi") return vi_booking_starting_package(inputs)
	if (locale === "sw") return sw_booking_starting_package(inputs)
	if (locale === "th") return th_booking_starting_package(inputs)
	if (locale === "bs") return bs_booking_starting_package(inputs)
	if (locale === "ja") return ja_booking_starting_package(inputs)
	if (locale === "ko") return ko_booking_starting_package(inputs)
	if (locale === "pt") return pt_booking_starting_package(inputs)
	if (locale === "it") return it_booking_starting_package(inputs)
	if (locale === "sv") return sv_booking_starting_package(inputs)
	if (locale === "nl") return nl_booking_starting_package(inputs)
	if (locale === "da") return da_booking_starting_package(inputs)
	if (locale === "nb") return nb_booking_starting_package(inputs)
	if (locale === "fi") return fi_booking_starting_package(inputs)
	if (locale === "pl") return pl_booking_starting_package(inputs)
	if (locale === "ru") return ru_booking_starting_package(inputs)
	if (locale === "tr") return tr_booking_starting_package(inputs)
	if (locale === "hi") return hi_booking_starting_package(inputs)
	if (locale === "id") return id_booking_starting_package(inputs)
	if (locale === "ms") return ms_booking_starting_package(inputs)
	if (locale === "cs") return cs_booking_starting_package(inputs)
	if (locale === "el") return el_booking_starting_package(inputs)
	if (locale === "he") return he_booking_starting_package(inputs)
	if (locale === "af") return af_booking_starting_package(inputs)
	if (locale === "hu") return hu_booking_starting_package(inputs)
	return en_booking_starting_package(inputs)
});